import { styled, Typography, Box } from '@mui/material'
import CardGraph, { CardGraphProps } from './Card.graph'
import { StringUtils } from '../../../utils/commons.utils'

const ValueTypo = styled(Typography)(() => ({
  textAlign: 'center',
  fontSize: '40px',
  fontWeight: 900,
  lineHeight: '1.10',
}))

const SubtitleTypo = styled(Typography)(({ theme }) => ({
  color: theme.palette.blockLabel,
  textAlign: 'center',
  fontSize: '12px',
  fontWeight: 400,
}))

export interface NumberGraphProps extends CardGraphProps {
  value: number | string
  subtitle?: string
  children?: React.ReactNode | React.ReactNode[]
}
const NumberGraph = (props: NumberGraphProps) => {
  const { value, subtitle, children, ...cardProps } = props
  return (
    <CardGraph {...cardProps}>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <ValueTypo>{StringUtils.formatNumber(value)}</ValueTypo>
        {subtitle && <SubtitleTypo>{subtitle}</SubtitleTypo>}
      </Box>
      {children}
    </CardGraph>
  )
}

export default NumberGraph
